/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import {
  FilterSection,
  SearchInput,
  AccountFilter,
  ClassificationFilter,
  ResetButton,
} from '../PersonalBusinessReviewView.styles';
import { ReviewTransactionFilters, LedgerAccount, JournalEntryClassificationValue } from '../types';

interface PersonalBusinessReviewFiltersProps {
  filterState: ReviewTransactionFilters;
  onFilterChange: (
    newState:
      | ReviewTransactionFilters
      | ((prev: ReviewTransactionFilters) => ReviewTransactionFilters),
  ) => void;
  onResetFilters: () => void;
  searchInputRef: React.RefObject<HTMLInputElement>;
  ledgerAccounts?: LedgerAccount[];
}

const classificationOptions = [
  { value: 'PERSONAL', label: 'Personal' },
  { value: 'BUSINESS', label: 'Business' },
];

export const PersonalBusinessReviewFilters: React.FC<PersonalBusinessReviewFiltersProps> = ({
  filterState,
  onFilterChange,
  onResetFilters,
  searchInputRef,
  ledgerAccounts = [],
}) => {
  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFilterChange(prev => ({ ...prev, search: e.target.value || null }));
    },
    [onFilterChange],
  );

  const handleAccountChange = useCallback(
    (accounts: LedgerAccount[] | null) => {
      onFilterChange(prev => ({ ...prev, accounts }));
    },
    [onFilterChange],
  );

  const handleClassificationChange = useCallback(
    (option: { value: JournalEntryClassificationValue; label: string } | null) => {
      onFilterChange(prev => ({ ...prev, classification: option ? option.value : null }));
    },
    [onFilterChange],
  );

  return (
    <FilterSection>
      <SearchInput
        ref={searchInputRef}
        type="text"
        placeholder="Search transactions..."
        defaultValue={filterState.search || ''}
        onChange={handleSearchChange}
      />

      <AccountFilter
        isMulti
        value={filterState.accounts}
        onChange={handleAccountChange}
        options={ledgerAccounts}
        getOptionLabel={option => option.name}
        getOptionValue={option => option.id}
        placeholder="All accounts"
        isClearable
      />

      <ClassificationFilter
        key={`classification-${filterState.classification || 'null'}`}
        value={classificationOptions.find(opt => opt.value === filterState.classification) || null}
        onChange={handleClassificationChange}
        options={classificationOptions}
        placeholder="All types"
        isClearable
      />

      <ResetButton onClick={onResetFilters}>Reset Filters</ResetButton>
    </FilterSection>
  );
};
